import { ReactElement } from 'react';
import { Button } from 'platform/components/shared/button/Button';
import { Component as ArrowNextIcon } from 'icons/icon-ui--arrow-next.svg';
import { Route } from 'platform/utils/config';
import { useNavigate } from 'react-router-dom';
import styles from './OrderConfirmation.module.scss';

export function WhileYouWait(): ReactElement {
  const navigate = useNavigate();

  return (
    <div className={styles.while_you_wait}>
      <h2 className={styles.header}>While you wait</h2>
      <p>Manage your account to make future weeks even easier.</p>
      <Button
        text="View Account Settings"
        rightIcon={ArrowNextIcon}
        onClick={() => {
          navigate(Route.PROFILE);
          window.scrollTo(0, 0);
        }}
      />
    </div>
  );
}
